import { useBilling } from "@/context/BillingContext";
import { Card } from "@/components/ui/card";
import { Button } from "@/components/ui/button";
import { Lock } from "lucide-react";
import { useNavigate } from "react-router-dom";

export default function PremiumGuard({ children, feature }) {
  const { info, isPremium } = useBilling();
  const navigate = useNavigate();
  // Billing not loaded yet → render nothing (layout shows loader)
  if (!info) return null;
  if (isPremium) return children;
  return (
    <div className="p-6 md:p-8 max-w-2xl mx-auto">
      <Card className="p-8 text-center" data-testid="premium-locked-screen">
        <div className="mx-auto h-14 w-14 rounded-full bg-secondary flex items-center justify-center mb-5">
          <Lock className="h-6 w-6 text-primary" />
        </div>
        <h1 className="font-display text-2xl font-semibold mb-2">
          {feature || "This feature"} is Premium
        </h1>
        <p className="text-muted-foreground mb-6">
          Upgrade to the Premium plan ($69/mo) to unlock {feature || "this feature"} and more.
        </p>
        <Button onClick={() => navigate("/owner/billing")} data-testid="premium-locked-upgrade">
          View plans
        </Button>
      </Card>
    </div>
  );
}
